import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Status } from '@vendasta/task';

@Injectable()
export class StatusSelectService {
  private readonly selectedStatus$$ = new BehaviorSubject<Status[]>([]);
  readonly selectedStatus$ = this.selectedStatus$$.asObservable();

  setStatus(statuses: Status[]): void {
    this.selectedStatus$$.next(statuses);
  }

  clearStatus(): void {
    this.selectedStatus$$.next([]);
  }
}
